import { timeout, delay } from '@ynap/promise-utils';
import { ResponseError, Person } from '@ynap/api-utils';
import { UPDATE_USER_MARKETING_LOCALE_REQUEST, UPDATE_USER_MARKETING_LOCALE_SUCCESS, UPDATE_USER_MARKETING_LOCALE_ERROR } from '../constants/ActionTypes';
import fetchUser from './fetchUser';
import { push } from 'connected-react-router';

function updateUserMarketingCountryLangRequest() {
    return {
        type: UPDATE_USER_MARKETING_LOCALE_REQUEST,
    };
}

function updateUserMarketingCountryLangSuccess() {
    return {
        type: UPDATE_USER_MARKETING_LOCALE_SUCCESS,
    };
}

function updateUserMarketingCountryLangError(error) {
    return {
        type: UPDATE_USER_MARKETING_LOCALE_ERROR,
        error,
    };
}

export default function updateUserMarketingCountryLang(user) {
    return (dispatch, getState, fetch) => {
        const { uberToken, locale, config, router } = getState();
        const { location = {} } = router;
        const { country } = locale;
        const { pathname } = location;
        const { clientRequest } = config.head || config;
        const { baseUrl, clientId, clientSecret } = config.watsonService || config.global.services.commerce;
        const { brandId } = config.watsonService || config.global.application;
        const { preferredLanguage, contextAttribute, ...rest } = user;

        const userForAPI = {
            ...(preferredLanguage && { preferredLanguage }),
            ...(contextAttribute && { contextAttribute }),
            ...rest,
        };

        const request = Person.userUpdate({
            baseUrl,
            brandId,
            country,
            user: userForAPI,
            uberToken,
            clientId,
            clientSecret,
            options: locale.langISO ? { locale: locale.langISO } : undefined,
        });

        dispatch(updateUserMarketingCountryLangRequest());

        return delay(timeout(fetch(request), clientRequest.timeout), clientRequest.delay)
            .then((response) => {
                const { ok, status } = response;

                if (ok) {
                    return response
                        .json()
                        .then(() => dispatch(updateUserMarketingCountryLangSuccess()))
                        .then(() => dispatch(fetchUser()));
                } else if (status === 401) {
                    return dispatch(push(`/${locale.id}/account/login?redirect=${pathname}`));
                }

                throw new ResponseError(response);
            })
            .catch((error) => {
                dispatch(updateUserMarketingCountryLangError(error));
                throw error;
            });
    };
}
